define([], function() {
	/**
	 * Swatches object 
	 * 
	 * This object is used to help modify 
	 * the product tile's elements like the 
	 * image, pdp links
	 */
	let swatches = {

		/**
		 * Purpose: replaces the image and pdp links
		 * for the targeted product tile 
		 * 
		 * @param {String} productId 
		 * @param {String} imageURL 
		 * @param {String} preSelectedPDPUrl
		 * @param {String} preSelectedProductLogonFormURL
		 */
		variantSelection: function(productId, imageURL, preSelectedPDPUrl, preSelectedProductLogonFormURL, colorOOS){
			let productTile = '#productTile_'+productId;
			let productImage = $(productTile).find('img.img-responsive');
			let productImgRef = $(productTile).find('.product-image-url');
			let productDescRef = $(productTile).find('.description a');
			let signInToBuyRef = $(productTile).find('#sign-in-to-buy');
			let productLogonFormURL = `javascript:window.location='${preSelectedProductLogonFormURL}'`;
			let ossImg = $(productTile).find('img.swatch-out-stock-overlay');
			
			productImage.attr('src', imageURL); // load new thumbnail image
			(colorOOS === 'true') ? ossImg.removeClass('hide') : ossImg.addClass('hide'); // show or hide OOS image overlay
			
			$(productTile).attr('data-pdp-url', preSelectedPDPUrl); // update pdp u for product tile
			productImgRef.attr('href', preSelectedPDPUrl); // update pdp url on image href
			productDescRef.attr('href', preSelectedPDPUrl); // update pdp url on product desc href
			signInToBuyRef.attr('onclick',productLogonFormURL); // update pdp url on sign in to buy button
		},

		/**
		 * How to test: 
		 * 
		 * 1 - Open PLP (search for "kirkland")
		 * 2 - Open dev tools > console
		 * 3 - run COSTCO.swatches.testVariantSelection();
		 * 
		 * Expected: 
		 * 
		 * The 1st Product tile's image
		 * should be replaced with the kirkland bear
		 */
		testVariantSelection: function(){
			let productId = $('.product-list .product').find('div .thumbnail').attr('itemid');
			let imageURL = 'https://wcs.costco.com/wcsstore/CostcoGLOBALSAS/images/bearOnKirklandWater_desktop.png'
			COSTCO.swatches.variantSelection(productId, imageURL);
		}
	}


	if (typeof window.COSTCO == 'undefined'){
		window.COSTCO = new Object();
	}	 
	window.COSTCO.swatches = swatches;
		return swatches;
}); 


// WEBPACK FOOTER //
// ./js/search/swatches.js